import React, { Component  } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import axios from 'axios'
import {parseQueryString} from './../utils/helper'
import * as  vars from './../constants/constants'
import { addFavoriteChannel, addFavoriteVideo, addLikesChannels, addLikesVideos } from './../actions/FavoriteActions';
import { getDetails, getInterests } from './../actions/AccountActions';
import { getVideoOrChannelRelatedData } from './../actions/PlayActions';
import { show, hide } from './../actions/ActivityIndicatorActions';
import { showMessage } from './../actions/FlashMessageActions';
import { addVideoHistory, addChannelHistory } from './../actions/HistoryActions';
import { setHeaderTitle } from './../actions/HeaderActions';
import { Videos360 } from './../constants/videos';
import { config } from './../constants/domainConfig';
import { addUid,checkAccess } from '../actions/WelcomeActions';

function getAllDataHOC(ComposedClass, updateDetails = false){
    class BaseClass extends Component{
        constructor(props){
            super(props);
            this.state = {
         
            }
            this.callApis=this.callApis.bind(this)
        }
        filterVideos(allVids){
            const restrictedVids = [27, 65];
            const restrictedVidsMe = [27, 50, 65, 91, 92];
            
            const vids = allVids.map(cat => {
                if(config.domain == 'me') 
                return {
                    ...cat,
                    "videos": cat.videos.filter(vid => restrictedVidsMe.indexOf(vid.id) == -1)
                }
                else return {
                    ...cat,
                    "videos": cat.videos.filter(vid => restrictedVids.indexOf(vid.id) == -1)
                }
            })
            return vids;       
        }
        componentWillMount()
        {
            if (!JSON.parse(sessionStorage.getItem('authorized')) || !JSON.parse(sessionStorage.getItem('authorized')).success) {
                axios.get(vars.BASE_API_URL+'/checkAccess?uid='+parseQueryString(this.props.location.search)['uid'] + '&domain=' + window.location.host)
                    .then((response) => {
                        let data = {
                            success: response.data.success,
                            uid: this.props.access.uid,
                            token: response.data.data.token
                        };
                        if (response.data.data.token != '') {
                            axios.defaults.headers.common['authorization'] = response.data.data.token;
                            this.callApis()
                        }
                        sessionStorage.setItem("authorized",JSON.stringify(data))
                        this.props.checkAccess(data);
                    })
                    .catch((error) => {
                        console_log(error);
                    });
            }
        }
        callApis(){
            this.props.category.videos= this.filterVideos(Videos360);

            if(this.props.account.interests.length<=0) {
    
                axios.all([axios.get(vars.BASE_API_URL + '/getUserProfile'), axios.get(vars.BASE_API_URL + '/interests'), axios.get(vars.BASE_API_URL + '/favorites'), axios.get(vars.BASE_API_URL + '/history'), axios.get(vars.BASE_API_URL + '/likes')])
                    .then(axios.spread((userProfile, interests, favorites, history, likes) => {
                        // for user details
                        if (userProfile.data.data) {
                            this.props.getDetails(userProfile.data.data);
                        }
    
                        // for interests
                        if (interests.data.data) {
                            this.props.getInterests(interests.data.data);
                        }
    
                        // for favorites
                        if (favorites.data.data) {
                            this.props.addFavoriteChannel(favorites.data.data.channels);
                            this.props.addFavoriteVideo(favorites.data.data.videos);
                        }
    
                        // for history
                        if (history.data.data) {
                            this.props.addChannelHistory(history.data.data.channels);
                            this.props.addVideoHistory(history.data.data.videos);
                        }
    
                        // for likes
                        if (likes.data.data) {
                            this.props.addLikesChannels(likes.data.data.channels);
                            this.props.addLikesVideos(likes.data.data.videos);
                        }
                    }));
            }else{
                    this.props.getDetails(this.props.account.user);
                    this.props.getInterests(this.props.account.interests);
                    this.props.addFavoriteChannel(this.props.favorite.channels);
                    this.props.addFavoriteVideo(this.props.favorite.videos);
                    this.props.addLikesChannels(this.props.favorite.channelsLiked);
                    this.props.addLikesVideos(this.props.favorite.videosLiked);
                    this.props.addChannelHistory(this.props.historyVideos.channels);
                    this.props.addVideoHistory(this.props.historyVideos.videos);
    
            }
        }
        componentDidMount() {
            this.props.addUid({
                uid : parseQueryString(this.props.location.search)['uid']
            });
        }
        componentDidUpdate(){
            
        }

        render(){
            return <ComposedClass {...this.props} {...this.state} />
        }
    }
    const mapDispatchToProps = dispatch => {
        return bindActionCreators({
            checkAccess,
            addUid,
            show,
            hide,
            getVideoOrChannelRelatedData,
            addFavoriteChannel,
            addFavoriteVideo,
            showMessage,
            setHeaderTitle,
            getDetails,
            addLikesChannels,
            addLikesVideos,
            getInterests,
            addVideoHistory,
            addChannelHistory
        }, dispatch);
    }

    const mapStateToProps = state => {
        return {
            access: state.WelcomeReducer,
            account: state.AccountReducer,
            category: state.CategoryReducer,
            country: state.CountryReducer,
            domain: state.DomainReducer,
            favorite: state.FavoriteReducer,
            flashmessage: state.FlashMessageReducer,
            historyVideos: state.HistoryReducer,
            loader: state.ActivityIndicatorReducer,
            play: state.PlayReducer,
            smartTV: state.SmartTVReducer,
            splash: state.SplashScreenReducer,
            user: state.AuthenticationReducer
            // CandidateDetails: state.CandidateDetails
        }
    }
    return connect(mapStateToProps, mapDispatchToProps)(BaseClass)
}

export default getAllDataHOC;


// WEBPACK FOOTER //
// ./src/containers/getAllDataHOC.js